import { useCallback, useEffect, useState } from "react";
import { vaccinationsApi } from "../api/endpoints/vaccinations";

export function useVaccinations(childId) {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(Boolean(childId));
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        if (!childId) {
            setRecords([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const data = await vaccinationsApi.list(childId);
            setRecords(data);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [childId]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    const bulkUpdate = useCallback(
        async (next) => {
            const updated = await vaccinationsApi.update(childId, next);
            setRecords(updated);
            return updated;
        },
        [childId]
    );

    return { records, loading, error, refetch, bulkUpdate };
}

/**
 * Loads the master vaccine catalogue in user-defined display order
 * (server-side `position`). Used by reports that join summary counts
 * onto each catalogue row.
 */
export function useVaccineCatalogue() {
    const [vaccines, setVaccines] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await vaccinationsApi.catalogue();
            setVaccines(data);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return { vaccines, loading, error, refetch };
}
